import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Workflow Management (leaf).
export const workflowManagement: ContentPage = {
  slug: "salesforce-automation/workflow-management",
  template: "hrmsFeature",
  seo: {
    title: "Workflow Automation Software - Automate Sales Workflows | GetBiz CRM",
    description:
      "Automate repetitive sales tasks with GetBiz CRM workflow automation software. Build no-code rules, triggers and actions that run your process for you.",
    keywords: [
      "workflow automation software",
      "sales workflow software",
      "CRM workflow automation",
      "no-code workflow automation",
      "business process automation",
      "sales automation rules",
    ],
    ogImage: "/assets/data/seoimages/workflow-management.webp",
  },
  leaf: {
    hero: {
      caption: "Workflow Management",
      title: "Automate the Busywork With No-Code Workflows",
      description:
        "Set up rules, triggers and actions once and let GetBiz CRM handle follow-ups, field updates, assignments and approvals — so your team spends time selling, not on admin.",
      h1: "caption",
    },
    split: {
      title: "Your Sales Process, Running on Autopilot",
      bullets: [
        { title: "No-Code Rules", description: "Build if-this-then-that workflows without a developer." },
        { title: "Triggers & Actions", description: "Fire tasks, emails and updates on any record change." },
        { title: "Approvals", description: "Route discounts and deals for approval automatically." },
        { title: "Assignment Rules", description: "Assign records to the right owner every time." },
      ],
      image: "/assets/images/img/product/crm/wokrflow-lead-image.webp",
      imageAlt: "GetBiz CRM workflow automation software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Workflow Management connects to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Lead Management", href: "/crm-software/salesforce-automation/lead-management/", description: "Automate lead scoring, routing and follow-up.", image: "/assets/images/img/product/crm/lead-managemnet-crm.webp", imageAlt: "CRM lead management" },
      { title: "Deal Management", href: "/crm-software/salesforce-automation/deal-management/", description: "Trigger tasks and updates as deals move through stages.", image: "/assets/images/img/product/crm/deal-management-image-Photoroom.webp", imageAlt: "CRM deal management" },
      { title: "Account Management", href: "/crm-software/salesforce-automation/account-management/", description: "Automate account reviews, renewals and updates.", image: "/assets/images/img/product/crm/account-management.webp", imageAlt: "CRM account management" },
      { title: "Cadences", href: "/crm-software/salesforce-automation/cadences/", description: "Trigger outreach sequences from any workflow rule.", image: "/assets/images/img/product/crm/cadence-image-Photoroom.webp", imageAlt: "CRM sales cadences" },
    ],
    testimonials: {
      title: "Do more with less using GetBiz CRM",
      description: "See why teams automate their sales process with GetBiz.",
    },
    bookDemoTitle: "Automate your sales process today.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sales-workflow-automation-guide, no-code-sales-automation",
    metaKey: "workflow-management",
  },
  sections: [],
};
